import logo from './logo.svg';
import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Indexs from './Indexs2.js';
import Dashboard2 from './Dashboards3.js'
import { AuthProvider } from './contexts/AuthContext';
//import Auth from './Auth.js';
//import Dashboard from './Dashboard.js';
import ContentPage from './ContentPage.js';
import LeadsPage from './LeadsPage.js';
import ReviewsPage from './ReviewPage2.js';
//import NotFound from './Notfound.js';
import BusinessSetup from './components/business/BusinessSetup';
import Auth2 from './Auth2.js';
import MFASetup from './MFASETUP.js';
import MFAVerify from './MFAVerify.js';
import PricingPage from './PricingPage.js';
import CookieConsent from "react-cookie-consent";
import Privacy from './Privacy.js';
import Terms from './Terms.js';
//import 
function App() {

  return (
    <div>
    <AuthProvider>
    <Router>
        <Routes>
        <Route path="/dashboard" element={<Dashboard2/>} />
        <Route path="/" element={<Indexs />} />
        <Route path="/auth" element={<Auth2 />} />
        <Route path="/pricingpage" element={<PricingPage/>} />
        <Route path="/business/setup" element={<BusinessSetup onComplete={false} />} />

        <Route path="/content" element={<ContentPage/>} />
        <Route path="/leadspage" element={<LeadsPage/>} />
        <Route path="/reviewspage" element={<ReviewsPage/>} />
        <Route path="/mfa-setup" element={<MFASetup/>} />
        <Route path="/mfa-verify" element={<MFAVerify/>} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      
        </Routes>
    </Router>
    
    <CookieConsent
          location="bottom"
          buttonText="Accept"
          declineButtonText="Decline"
          enableDeclineButton
          cookieName="travel_cookie_consent"
          style={{ background: "#111827" }}
          buttonStyle={{ background: "#6366f1", color: "#fff", fontSize: "14px" }}
          declineButtonStyle={{ background: "#374151", color: "#fff", fontSize: "14px" }}
          expires={150}
        >
          We use cookies to improve your experience, analyze traffic, and personalize content.
        </CookieConsent>
    </AuthProvider>
  </div>
  );
}

export default App;
